import { Spin } from "antd";
import { Navigate, Outlet } from "react-router-dom";
import { useProfile } from "@/hooks/useProfile";
import { DEFAULT_AUTHENTICATED_HOME } from "@/lib/routes";

/**
 * Guard for the channel-connect settings page, gated by the
 * `connect_platform` permission (owners have it via their wildcard; admins
 * only if granted it in the member-permissions modal). Users without it are
 * redirected home. The backend also enforces this server-side
 * (requirePermission ConnectPlatform); the guard just avoids a dead-end 403
 * when the URL is opened directly.
 *
 * While the profile is still loading we render a spinner (avoids a redirect
 * flash before we know the permissions).
 */
export function RequireConnectPlatform() {
  const { profileLoaded, canConnectPlatform } = useProfile();

  if (!profileLoaded) {
    return (
      <div className="flex h-full items-center justify-center p-8">
        <Spin />
      </div>
    );
  }

  if (!canConnectPlatform) {
    return <Navigate to={DEFAULT_AUTHENTICATED_HOME} replace />;
  }

  return <Outlet />;
}
